var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container pt-4",staticStyle:{"max-width":"45rem"}},[_c('h1',[_vm._v("Home")]),_c('CreatePost'),(_vm.loading)?_c('div',[_c('PlaceholderPost')],1):_vm._e(),_vm._l((_vm.posts),function(post){return _c('PostListItem',{key:post.id,attrs:{"post":post}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }